import axios from 'axios';
import { QueryParamsInterface } from '../../../types/Shared';
import { baseUrl, HttpMethods } from '../../base';
import {
  GetVendorsService,
  PostAssignTDMVendorService,
  PostVendorInviteService,
} from './types';

const svtnBasePath = `${baseUrl.SHERPA}/svtn/vendors`;
const sherpaVendorsBasePath = `${baseUrl.SHERPA}/vendors`;

export async function postVendorInvite({ data }: PostVendorInviteService) {
  const resp = await axios.request({
    method: HttpMethods.POST,
    url: `${svtnBasePath}/invite`,
    data,
  });
  return resp.data;
}

export async function getVendors({ params }: GetVendorsService) {
  const res = await axios.request({
    method: HttpMethods.GET,
    url: `${svtnBasePath}/search`,
    params,
  });
  return res.data;
}

export async function postAssignTDMVendor({
  data,
}: PostAssignTDMVendorService) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${svtnBasePath}/assign`,
    data,
  });
  return res.data;
}

//Sherpa Vendors

interface GetSherpaVendorsService {
  params?: QueryParamsInterface;
}

export async function getSherpaVendors({ params }: GetSherpaVendorsService) {
  const res = await axios.request({
    method: HttpMethods.GET,
    url: `${sherpaVendorsBasePath}/search`,
    params,
  });

  return res.data;
}

interface IPostSherpaVendorsService {
  data: IPostSherpaVendorsPayload;
}

export interface IPostSherpaVendorsPayload {
  organizationName: string;
  email: string;
}

export async function postSherpaVendors({ data }: IPostSherpaVendorsService) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${sherpaVendorsBasePath}/invite`,
    data,
  });

  return res.data;
}

// WARNING Use Carefully
export async function deleteAllUnusedVendor() {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${sherpaVendorsBasePath}/remove-unused-vendor`,
  });

  return res.data;
}
